import { r as registerInstance, h } from './index-e3eeb4ec.js';
import { L as Locale } from './index-6afae4e4.js';
const indexCss = "button.phx-options-menulist-back-button{display:flex;background:none;width:100%;padding:8px;border:0;border-bottom:1px solid #585858;cursor:pointer}button.phx-options-menulist-back-button>svg{pointer-events:none;border-radius:4px}button.phx-options-menulist-back-button strong{pointer-events:none;color:#fff;font-size:0.8rem;font-weight:700;line-height:24px;margin-left:4px}button.phx-options-menulist-back-button:hover>svg{background-color:#353535}button.phx-options-menulist-back-button:focus{outline:2px solid #EE0000;outline-offset:-1px;border-radius:8px 8px 0 0}";
const OptionsMenuBackBtnStyle0 = indexCss;
const OptionsMenuBackBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
  }
  componentDidLoad() {
    this.backbutton.focus();
  }
  handleClick() {
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "options-menu-back-btn",
      interactionName: "back",
      interactionType: "click"
    });
  }
  render() {
    return h("button", {
      key: '17fc0d64c6bef11b73cd87602aec659294ce02af',
      class: "phx-options-menulist-back-button",
      type: "button",
      "data-name": "back button",
      "data-value": "menuback",
      "aria-label": this.locale.backToPreviousMenu,
      ref: el => this.backbutton = el
    }, h("svg", {
      key: 'd3f5b8aedb190fe3b097418203dcceb9612453de',
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      focusable: "false",
      role: "presentation",
      xmlns: "http://www.w3.org/2000/svg"
    }, h("rect", {
      key: '72becdb9c266d5d11fce7dda51ff62828c70ba92',
      width: "24",
      height: "24",
      rx: "12"
    }), h("path", {
      key: 'a81c4878cb720be45e7a5c703ff9aa985b98cb88',
      d: "M14.9099 6.70998C14.5199 6.31998 13.8899 6.31998 13.4999 6.70998L8.90993 11.3C8.51993 11.69 8.51993 12.32 8.90993 12.71L13.4999 17.3C13.8899 17.69 14.5199 17.69 14.9099 17.3C15.2999 16.91 15.2999 16.28 14.9099 15.89L11.0299 12L14.9099 8.11998C15.2899 7.72998 15.2899 7.08998 14.9099 6.70998Z",
      fill: "white"
    })), h("strong", {
      key: 'a6aeb8672c9770c6492e4ae31817b382bb08f93a'
    }, this.menuTitle));
  }
};
OptionsMenuBackBtn.style = OptionsMenuBackBtnStyle0;
export { OptionsMenuBackBtn as options_menu_back_btn };